

const { $ } = window
const $body = $(document.body)


function runPageBlocks() {
  if($body.hasClass('home')) {
  }

  if (document.querySelector('.clients-and-partners')) {
    if (document.querySelector('#show-more-button-1')) {
      document.querySelector('#show-more-button-1').addEventListener('click', function() {
        document.querySelector('#show-more-button-1').style.display = 'none';
       $('#show-more-1').slideToggle();
       $('#show-more-1').css('display', 'flex');
      });
    }
  
    if (document.querySelector('#show-more-button-2')) {
      document.querySelector('#show-more-button-2').addEventListener('click', function() {
        document.querySelector('#show-more-button-2').style.display = 'none';
        $('#show-more-2').slideToggle()
        $('#show-more-2').css('display', 'flex');
        //$('#show-more-1').style.display = 'none';
      });
    }
  }
}

export { 
  runPageBlocks
}